export const state = {
	takeContact: 'Not done',
	offer: 'Offered',
	deal: 'Sale',
	installed: 'Done',
};
